export default __webpack_public_path__ + "3580cdfee41432af81025d1caf0f365e.png";